import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'distributor-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class DistributorFooterComponent implements OnInit {
  cpYear:any='';
  constructor() { }

  ngOnInit() {
    let date=new Date();
    this.cpYear=date.getFullYear();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/distributor/footer/footer.component.ts